import React, { useState, cloneElement } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "@material-ui/core/Button/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import { Slide } from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import DialogContent from "@material-ui/core/DialogContent";
import { Adjust, Restore, Close } from "@material-ui/icons";
import DialogActions from "@material-ui/core/DialogActions";
import SectionHeader from "../../../../components/UI/SectionHeader";
import portfolioAction from "../../../../actions/portfolio.action";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import moment from "moment";
import StepContent from "@material-ui/core/StepContent";
import Typography from "@material-ui/core/Typography";
import { withRouter } from "react-router-dom";

const styles = (theme) => ({
  paper: {
    width: "100%",
  },
  modalCloseBtn: {
    position: "absolute",
    top: 10,
    right: 10,
  },
  dialogContent: {
    maxHeight: 300,
    border: `1px solid ${theme.palette.grey["A200"]}`,
    margin: `0 30px`,
    padding: 0,
  },
  viewButton: {
    marginTop: 4,
    fontSize: 12,
  },
});

const PortfolioHistoryModal = (props) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { classes, dialogAnchorComponent, portfolioId, householdId } = props;
  const portfolioHistory = useSelector(
    (state) => state.portfolio.portfolioHistory
  );
  const loading = useSelector(
    (state) => state.portfolio.portfolioHistoryLoading
  );

  const handleOpenModal = () => {
    setOpen(true);
    dispatch(portfolioAction.getPortfolioHistory(portfolioId));
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  const StepIcon = (props) => {
    const { active } = props;
    if (active) {
      return <Restore fontSize="small" color={"primary"} />;
    }
    return <Adjust fontSize="small" color={"disabled"} />;
  };

  const viewSummary = (requestingPortfolioId) => (e) => {
    setOpen(false);
    if (requestingPortfolioId !== portfolioId) {
      props.history.push(
        `/Portal/household/${householdId}/summary/${requestingPortfolioId}`
      );
    }
  };

  if (!dialogAnchorComponent) {
    return null;
  }

  return (
    <React.Fragment>
      {cloneElement(dialogAnchorComponent, { onClick: handleOpenModal })}

      <Dialog
        open={open}
        TransitionComponent={Slide}
        TransitionProps={{ direction: "up" }}
        onClose={handleCloseModal}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        aria-labelledby="disclosure-modal-title"
        maxWidth={"sm"}
        scroll={"paper"}
        classes={{ paper: classes.paper }}
      >
        <DialogTitle id="household-settings-modal-title" disableTypography>
          <SectionHeader text={"Portfolio History"} />
          <IconButton
            className={classes.modalCloseBtn}
            aria-label="Close"
            onClick={handleCloseModal}
          >
            <Close color="primary" />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          {loading ? (
            <Grid container alignContent={"center"} justify={"center"}>
              <Grid item xs={12}>
                <CircularProgress size={50} />
              </Grid>
            </Grid>
          ) : (
            <Stepper activeStep={0} orientation="vertical">
              {portfolioHistory.map((p) => {
                return (
                  <Step key={p.uuid} expanded>
                    <StepLabel StepIconComponent={StepIcon}>
                      <Typography variant={"body1"}>
                        {moment(p.updatedAt).format("MM/DD/YYYY")}
                      </Typography>
                    </StepLabel>
                    <StepContent>
                      <Typography variant={"caption"}>
                        Portfolio Name
                      </Typography>
                      <Typography variant={"body1"} color={"primary"}>
                        {p.name}
                      </Typography>
                      <Typography variant={"caption"}>Strategy</Typography>
                      <Typography
                        variant={"body1"}
                        color={"primary"}
                        gutterBottom
                      >
                        {p.cprName}
                      </Typography>
                      <Button
                        size="small"
                        variant={"outlined"}
                        color={"primary"}
                        className={classes.viewButton}
                        onClick={viewSummary(p.uuid)}
                      >
                        View Summary
                      </Button>
                    </StepContent>
                  </Step>
                );
              })}
            </Stepper>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={handleCloseModal}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default withRouter(withStyles(styles)(PortfolioHistoryModal));



// WEBPACK FOOTER //
// ./src/containers/Cy/components/PortfolioHistoryModal/index.jsx